// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1hL26","tab":"TabNav_tab__1AKxj","link":"TabNav_link__YcjZs","selectedLink":"TabNav_selectedLink__2k1N2","disabled":"TabNav_disabled__1icAZ"};